import { render, staticRenderFns } from "./single-stand.vue?vue&type=template&id=0dc98d88&"
import script from "./single-stand.vue?vue&type=script&lang=js&"
export * from "./single-stand.vue?vue&type=script&lang=js&"
import style0 from "./single-stand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports